var map = {
	"./Ablenkung.jpg": "7d3a",
	"./Ablenkung.png": "8c09",
	"./BG.jpg": "bede",
	"./Dooring.jpg": "efbc",
	"./HaltenderPKW.jpg": "9ca2",
	"./HaltenderPKW.png": "5b59",
	"./RechtsAbbiegen.jpg": "6ebc",
	"./Ueberholen.jpg": "07a2",
	"./Zebrastreifen.jpg": "713d",
	"./alert2.svg": "c832",
	"./altOpt.svg": "dcd2",
	"./button_situation.svg": "0e60",
	"./fonts/DINNextLTPro-Bold.eot": "2e7b",
	"./fonts/DINNextLTPro-Bold.ttf": "4544",
	"./fonts/DINNextLTPro-Bold.woff": "2f34",
	"./fonts/DINNextLTPro-Bold.woff2": "12f2",
	"./fonts/DINNextLTPro-Regular.eot": "e376",
	"./fonts/DINNextLTPro-Regular.ttf": "f643",
	"./fonts/DINNextLTPro-Regular.woff": "d8cb",
	"./fonts/DINNextLTPro-Regular.woff2": "43eb",
	"./fonts/Glitch inside.otf": "65b5",
	"./fullscreen.svg": "8625",
	"./fullscreen_back.svg": "6fcb",
	"./home_gfx1.svg": "07cc",
	"./home_gfx2.svg": "33d1",
	"./icons_UI_chevron_left.svg": "0226",
	"./icons_UI_chevron_right.svg": "ab03",
	"./icons_UI_chevron_right_black.svg": "e6f6",
	"./icons_UI_icon_X.svg": "d338",
	"./icons_UI_icon_X_auswertung.svg": "92b5",
	"./icons_UI_icon_again.svg": "a096",
	"./icons_UI_icon_again_black.svg": "2b4e",
	"./icons_UI_icon_check.svg": "b942",
	"./icons_UI_icon_check_mint.svg": "d3fe",
	"./icons_UI_icon_missed.svg": "92e9",
	"./icons_UI_icon_missed_mint.svg": "9a82",
	"./icons_UI_icon_wrong.svg": "e93e",
	"./icons_UI_outlink.svg": "7de5",
	"./icons_UI_pause.svg": "ad3b",
	"./icons_attention.svg": "1bdb",
	"./icons_attention_mint.svg": "9ea2",
	"./icons_fahrrad_mint.svg": "0604",
	"./icons_illu_auto_hoehe.svg": "a0965",
	"./icons_illu_fahrrad.svg": "7382",
	"./pause.svg": "ec7e",
	"./pause2.svg": "8350",
	"./play.svg": "5830",
	"./space_key.svg": "dd06",
	"./strgCtrl.svg": "a133",
	"./swoosh1.aac": "fa18",
	"./swoosh1.mp3": "ef0d",
	"./swoosh1.ogg": "42cf",
	"./swoosh2.aac": "2e5b",
	"./swoosh2.mp3": "457e",
	"./swoosh2.ogg": "a0ee",
	"./tutorial_BG_auto.jpg": "9b31",
	"./tutorial_BG_auto2.jpg": "50af",
	"./tutorial_BG_fahrrad.jpg": "a3bf",
	"./tutorial_BG_fahrrad2.jpg": "a310"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";